export default "__VITE_ASSET__9824070e__"